import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.map";
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { ProductPropType } from "web/types/product";
import Expandable from "web/react/components/expandable/expandable";
import ReadMoreLess from "web/react/components/read-more-less/read-more-less";
import styles from "./product-description-details.css";

function ProductDescriptionDetails(_ref) {
  var product = _ref.product,
      className = _ref.className,
      productAreaAccordions = _ref.productAreaAccordions;
  var productDescriptionContent = React.createElement(React.Fragment, null, React.createElement("p", {
    className: styles.noMarginTop
  }, product.long_description), product.more_descriptions && product.more_descriptions.descriptions && product.more_descriptions.descriptions.map(function (productDescription) {
    return React.createElement(React.Fragment, {
      key: productDescription.from_retailer_name
    }, React.createElement("h4", null, productDescription.from_retailer_name), React.createElement("p", null, productDescription.short_description), React.createElement("p", null, productDescription.description));
  }));
  return productAreaAccordions ? React.createElement("div", {
    className: className
  }, React.createElement(Expandable, {
    renderLabel: function renderLabel() {
      return React.createElement("h4", null, gettext("in_stock_product.details"));
    },
    onClick: function onClick(isOpen) {
      if (!isOpen) {
        analytics.event("product area", "click", "open-details");
      }
    }
  }, React.createElement("div", null, productDescriptionContent))) : React.createElement("div", {
    className: classnames(className)
  }, React.createElement("h4", null, gettext("in_stock_product.details")), React.createElement(ReadMoreLess, {
    key: product.product_id
  }, productDescriptionContent));
}

ProductDescriptionDetails.propTypes = {
  product: ProductPropType.isRequired,
  className: PropTypes.string,
  productAreaAccordions: PropTypes.bool
};
ProductDescriptionDetails.defaultProps = {
  productAreaAccordions: false
};
export default ProductDescriptionDetails;